import { createAsyncThunk } from '@reduxjs/toolkit';

export const getFilesThunk = createAsyncThunk(
    'file/get',
    async (params, { extra, rejectWithValue }) => {
        try {
            const res = await extra.fileService.get(params);
            return res;
        } catch (err) {
            return rejectWithValue(err?.response?.data || err.message);
        }
    }
);

export const uploadFileThunk = createAsyncThunk(
    'file/upload',
    async (formData, { extra, rejectWithValue }) => {
        try {
            const res = await extra.fileService.upload(formData);
            return res;
        } catch (err) {
            return rejectWithValue(err?.response?.data || err.message);
        }
    }
);

export const downloadFileThunk = createAsyncThunk(
    'file/download',
    async (params, { extra, rejectWithValue }) => {
        try {
            const blob = await extra.fileService.download(params);
            return blob;
        } catch (err) {
            return rejectWithValue(err?.response?.data || err.message);
        }
    }
);

export const deleteFileThunk = createAsyncThunk(
    'file/delete',
    async (params, { extra, rejectWithValue }) => {
        try {
            const res = await extra.fileService.delete(params);
            return res;
        } catch (err) {
            return rejectWithValue(err?.response?.data || err.message);
        }
    }
);
